import { WSCard, WSText } from "@wingspanhq/fe-component-library";
import { RequirementType } from "@wingspanhq/wingspan-api-sdk";
import { queriesRequirements, queriesPayers } from "@query";
import { selectorPayerDisplayName } from "../../../shared/selectors/selectorPayerDisplayName";

export const CardTaxVerificationRequirementRequester = () => {
  const queryRequirements = queriesRequirements.listPayeeRequirements.useQuery(
    {}
  );

  const hasTaxVerificationRequirement = (
    queryRequirements.data?.data ?? []
  ).some(
    requirement =>
      requirement.type === RequirementType.TAX_VERIFICATION &&
      // A requirement now lists every engagement it is attached to; empty means
      // it is payee-level rather than engagement-level.
      (requirement.payeeEngagementIds?.length ?? 0) > 0
  );

  const queryPayers = queriesPayers.listPayers.useQuery(
    {},
    { enabled: hasTaxVerificationRequirement }
  );

  const payerNames = (queryPayers.data?.data ?? []).map(payer =>
    selectorPayerDisplayName(payer)
  );

  return (
    <WSCard header="Taxpayer info">
      <WSText.ParagraphSm color="gray600">
        Complete your account setup by providing your taxpayer information below
        as required by {payerNames.join(", ")}
      </WSText.ParagraphSm>
    </WSCard>
  );
};
